// Mui css media query object for SSR

export const hideOnDesktop = {
    display: { xs: 'flex', md: 'none' }
};

export const hideOnMobile = {
    display: { xs: 'none', md: 'flex' },
};